const Tabs = r => require.ensure([], () => r(require('./Tabs.vue')), 'shared')
const TabList = r => require.ensure([], () => r(require('./TabList.vue')), 'shared')
const TabPane = r => require.ensure([], () => r(require('./TabPane.vue')), 'shared')

// import Tabs from './Tabs'
// import TabList from './TabList'
// import TabPane from './TabPane'

export { Tabs, TabList, TabPane }
